import PropTypes from 'prop-types';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TimelineMonthLabel({
  children,
  marginBlockStart
}) {
  return /*#__PURE__*/_jsx(Text, {
    marginBlockStart: marginBlockStart,
    marginInlineStart: "100",
    marginBlockEnd: "0",
    "data-selenium-test": "timeline-month-label",
    typography: "body-200",
    children: children
  });
}
TimelineMonthLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};